export default __webpack_public_path__ + "static/media/DBS_Bank_logo_logotype.44a7a9c8.png";